import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @param {Number|String} ticketId
 * @return {Promise<Object>} Contacto
 */

export async function fetchPhoneContact(id, ticketId) {
  const url = ticketId
    ? `/contacts/clients/${id}/phones/?ticket_id=${ticketId}`
    : `/contacts/clients/${id}/phones/`;
  const response = await httpManager.get(url);
  return response?.data;
}
